<div [class.working]="working" [class.standalone]="!listing">

    <article class="lib-elevation-1" [id]="instanceId + '-budget'" [class.expand]="step === 'Budget' && !listing"
        [hidden]="!!listing">

        <nav class="lib-nav" (click)="budgetGroupToggle($event)">
            <div class="lib-badge" [hidden]="!!listing">
                <span>STEP 1</span>
            </div>
            <h6>Calculate&nbsp;budget</h6>
            <p class="lib-legend non-mobile">How much could you afford with Proportunity</p>
            <h6 class="lib-legend" [hidden]="!budgetScenario"><sup>UP&nbsp;TO</sup>&nbsp;{{budgetScenario?.budget || 0 |
                currency:'GBP':'symbol':'1.0'}}</h6>
            <span class="lib-spacer"></span>
            <!-- <div class="lib-badge">
                <span>INDICATIVE</span>
            </div> -->
        </nav>
        <form [formGroup]="budgetGroup" (ngSubmit)="budgetGroupSubmit($event)">

            <div class="flex-c">

                <span class="lib-spacer"></span>

                <div class="flex-c container">

                    <nav class="lib-nav">
                        <hr>
                        <button (click)="budgetFocusSet(0)" type="button"
                            [class]="budgetFocus === 0 ? 'lib-button-primary' : 'lib-button'">
                            <lib-icon name="profile"></lib-icon>
                            <span><strong class="non-mobile">Applicant</strong> #1</span>
                        </button>
                        <hr>
                        <button [hidden]="budgetGroup.get('number_of_applicants').value != applicantsOptions[1].value"
                            (click)="budgetFocusSet(1)" type="button"
                            [class]="budgetFocus === 1 ? 'lib-button-primary' : 'lib-button'">
                            <lib-icon name="profile"></lib-icon>
                            <span><strong class="non-mobile">Applicant</strong> #2</span>
                        </button>
                        <hr>
                        <span class="lib-spacer"></span>
                        <span class="lib-spacer-fixed"></span>
                        <lib-select class="nav-toggle" theme="stroked" formControlName="number_of_applicants"
                            [options]="applicantsOptions"></lib-select>
                    </nav>

                    <div class="flex-r">

                        <div class="flex-c">
                            <span class="lib-legend">Residency status <sup>*</sup></span>
                            <lib-select theme="stroked" formControlName="residence_type"
                                [theme]="budgetGroup.get('residence_type').valid ? 'stroked' : 'stroked-warn'"
                                [options]="residencyOptions">
                            </lib-select>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Employment status <sup>*</sup></span>
                            <lib-select formControlName="employment_type"
                                [theme]="budgetGroup.get('employment_type').valid ? 'stroked' : 'stroked-warn'"
                                [options]="employmentOptions">
                            </lib-select>
                        </div>

                        <div class="flex-c employment-type"
                            [class.toggle]="budgetGroup.get('employment_type').value === employmentOptions[2].value">
                            <span class="lib-legend">Self-employment type <sup>*</sup></span>
                            <lib-select formControlName="self_employment_type"
                                [theme]="budgetGroup.get('self_employment_type').valid ? 'stroked' : 'stroked-warn'"
                                [options]="selfEmploymentOptions">
                            </lib-select>
                        </div>

                        <div class="flex-c"></div>

                        <div class="flex-c">
                            <span class="lib-legend">Date of birth <sup>*</sup></span>
                            <lib-input prefixIcon="calendar" formControlName="dob" type="date" placeholder=""
                                [class.warn]="budgetGroup.get('dob').invalid">
                            </lib-input>
                        </div>

                    </div>

                    <!-- EMPLOYED  -->
                    <div class="flex-r"
                        [hidden]="!(budgetGroup.get('employment_type').value === employmentOptions[1].value)">

                        <div class="flex-c">
                            <span class="lib-legend">Basic salary <sup>*</sup></span>
                            <lib-input prefixIcon="gbp" formControlName="income_basic" type="currency" placeholder=""
                                [class.warn]="budgetGroup.get('income_basic').invalid">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Bonus</span>
                            <lib-input prefixIcon="gbp" formControlName="income_bonus" type="currency" placeholder="">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Overtime</span>
                            <lib-input prefixIcon="gbp" formControlName="income_overtime" type="currency" placeholder="">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Commission</span>
                            <lib-input prefixIcon="gbp" formControlName="income_commission" type="currency"
                                placeholder=""></lib-input>
                        </div>

                    </div>

                    <!-- SELF EMPLOYED :: SOLE TRADER -->
                    <div class="flex-r" [hidden]="
                        !(budgetGroup.get('employment_type').value === employmentOptions[2].value &&
                        budgetGroup.get('self_employment_type').value === selfEmploymentOptions[1].value)">

                        <div class="flex-c">
                            <span class="lib-legend">Net profit <sup>*</sup></span>
                            <lib-input prefixIcon="gbp" formControlName="income_net_profit_latest" type="currency"
                                placeholder="latest year"
                                [class.warn]="budgetGroup.get('income_net_profit_latest').invalid">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">&nbsp;</span>
                            <lib-input prefixIcon="gbp" formControlName="income_net_profit_previous" type="currency"
                                placeholder="previous year"
                                [class.warn]="budgetGroup.get('income_net_profit_previous').invalid">
                            </lib-input>
                        </div>

                        <div class="flex-c"></div>
                        <div class="flex-c"></div>

                    </div>

                    <!-- SELF EMPLOYED :: COMPANY DIRECTOR -->
                    <div class="flex-r" [hidden]="
                    !(budgetGroup.get('employment_type').value === employmentOptions[2].value &&
                    budgetGroup.get('self_employment_type').value === selfEmploymentOptions[2].value)">

                        <div class="flex-c">
                            <span class="lib-legend">Salary<sup>*</sup></span>
                            <lib-input prefixIcon="gbp" formControlName="income_salary_latest" type="currency"
                                placeholder="latest year"
                                [class.warn]="budgetGroup.get('income_salary_latest').invalid"></lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">&nbsp;</span>
                            <lib-input prefixIcon="gbp" formControlName="income_salary_previous" type="currency"
                                placeholder="previous year"
                                [class.warn]="budgetGroup.get('income_salary_previous').invalid">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Dividends</span>
                            <lib-input prefixIcon="gbp" formControlName="income_dividends_latest" type="currency"
                                placeholder="">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">&nbsp;</span>
                            <lib-input prefixIcon="gbp" formControlName="income_dividends_previous" type="currency"
                                placeholder="">
                            </lib-input>
                        </div>

                    </div>

                </div>

                <span class="lib-spacer-fixed"></span>

                <div class="flex-c container">

                    <nav class="lib-nav xs">
                        <h6>Deposit &amp; Outgoings</h6>
                    </nav>

                    <div class="flex-r">

                        <div class="flex-c">
                            <span class="lib-legend">Total savings <sup>*</sup></span>
                            <lib-input prefixIcon="gbp" formControlName="savings" type="currency" placeholder=""
                                [class.warn]="budgetGroup.get('savings').invalid">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Dependants</span>
                            <lib-select theme="stroked" formControlName="number_of_dependants"
                                [options]="dependantOptions">
                            </lib-select>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Total outstanding credit</span>
                            <lib-input prefixIcon="gbp" formControlName="total_credit_commitments" type="currency"
                                placeholder="">
                            </lib-input>
                        </div>

                        <div class="flex-c">
                            <span class="lib-legend">Monthly credit outgoings</span>
                            <lib-input prefixIcon="gbp" formControlName="monthly_credit_commitments" type="currency"
                                placeholder="">
                            </lib-input>
                        </div>

                    </div>

                    <div class="flex-r" hidden>
                        <span class="lib-spacer-fixed"></span>
                        <lib-checkbox formControlName="savings_include_stamp_duty">Savings include Stamp duty
                        </lib-checkbox>
                    </div>

                </div>

                <span class="lib-spacer"></span>
                <span class="lib-spacer-fixed"></span>

                <div class="flex-c container output">
                    <nav class="lib-nav">
                        <lib-icon name="calculator"></lib-icon>
                        <h6><sup>UP&nbsp;TO</sup>&nbsp;budget</h6>
                        <p class="lib-legend non-mobile">Indicative amount based on details provided</p>
                        <span class="lib-spacer"></span>
                        <span class="lib-spacer-fixed"></span>
                        <lib-select
                            title="Leasehold properties typically come attached with other associated costs such as service charges & ground rent which may affect your overall affordability"
                            class="nav-toggle" theme="stroked" formControlName="tenure" [options]="tenureOptions">
                        </lib-select>
                    </nav>
                    <div class="flex-r">
                        <div class="flex-c highlight-x">
                            <span class="lib-legend legend-x">{{budgetStore?.application?.term}}yrs
                                {{budgetStore?.application?.tenure}}</span>
                            <h3>{{budgetScenario?.budget || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>
                        <div class="flex-c">
                            <div class="lib-badge">
                                <span>Indicative</span>
                            </div>
                        </div>
                        <!-- <div class="flex-c"></div> -->
                        <div class="flex-c" hidden>
                            <!-- [hidden]="!(budgetStore?.applicants?.[0]?.dob || budgetStore?.applicants?.[1]?.dob)"-->
                            <span class="lib-legend legend-x">Max Term</span>
                            <h3>{{budgetStore?.application?.term || 0 }} yrs</h3>
                        </div>
                        <div class="flex-r center" hidden>
                            <lib-select formControlName="product" theme="stroked" [options]="productOptions">
                            </lib-select>
                            <span class="lib-spacer"></span>
                        </div>
                        <div class="flex-c highlight">
                            <button class="lib-button-flat-primary end full-width" type="submit"
                                [disabled]="budgetGroup.invalid || ((budgetScenario?.budget || 0) < 100000)">
                                <span>Cost Breakdown</span>
                                <span class="lib-spacer"></span>
                                <lib-icon name="chevronRight"></lib-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <span class="lib-spacer"></span>

            </div>

            <input formControlName="term" type="number" hidden>

        </form>
    </article>

    <article class="lib-elevation-1" [id]="instanceId + '-breakdown'" [class.expand]="step === 'Breakdown'"
        [class.first-child]="!!listing">
        <!--[class.first-child]="!!listing"-->

        <nav class="lib-nav" [class.locked]="step === 'Budget'" (click)="breakdownGroupToggle($event)">
            <div class="lib-badge" [hidden]="!!listing">
                <span>STEP 2</span>
            </div>
            <!-- <lib-icon name="calculator" [hidden]="!!listing"></lib-icon> -->
            <h6>Cost Breakdown</h6>
            <!-- <h6 [hidden]="!breakdownScenario?.recommendation?.total_per_month">
                {{breakdownScenario?.recommendation?.loan || 0 |
                currency:'GBP':'symbol':'1.0'}}</h6> -->
            <p class="non-mobile lib-legend">How much could your borrowing cost</p>
            <h6 class="lib-legend" [hidden]="!breakdownScenario?.recommendation?.total_per_month">
                {{breakdownScenario?.recommendation?.total_per_month || 0 |
                currency:'GBP':'symbol':'1.0'}} per month</h6>
            <span class="lib-spacer"></span>
            <div class="lds-grid" [hidden]="!working">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <!-- <lib-icon name="info"></lib-icon> -->
            <button *ngIf="step === 'Breakdown'" class="lib-button" type="button" (click)="previousStep($event)"
                [hidden]="!!listing || !!working">
                <lib-icon name="chevronUp"></lib-icon>
                <!-- <span>Back</span> -->
            </button>
        </nav>
        <form [formGroup]="breakdownGroup" (ngSubmit)="breakdownGroupSubmit($event)">

            <div class="flex-c">

                <span class="lib-spacer"></span>

                <div class="flex-c">

                    <!-- <nav class="lib-nav">
                        <lib-icon name="home"></lib-icon>
                        <p>Property</p>
                        <span class="lib-spacer"></span>
                    </nav> -->

                    <!-- <div class="flex-r"> -->

                    <div class="flex-c un-pad mx">
                        <!---->
                        <lib-range formControlName="purchase_price" [options]="budgetOptions">
                        </lib-range>
                        <div class="flex-r un-pad" hidden>
                            <span class="lib-spacer"></span>
                            <lib-select theme="stroked" formControlName="tenure" [options]="tenureOptions">
                            </lib-select>
                            <!-- <span class="lib-spacer-fixed"></span> -->
                        </div>
                    </div>

                    <div class="flex-c un-pad" hidden>
                        <lib-range formControlName="deposit" [options]="depositOptions">
                        </lib-range>
                    </div>

                    <!-- </div> -->
                </div>

                <span class="lib-spacer"></span>
                <span class="lib-spacer-fixed"></span>

                <div class="flex-c container output" [hidden]="!breakdownScenario">

                    <nav class="lib-nav">
                        <lib-icon name="calculator"></lib-icon>
                        <h6 class="non-mobile">Total borrowing &amp; per month cost</h6>

                        <div class="lib-badge">
                            <span>Indicative</span>
                        </div>

                        <span class="lib-spacer"></span>

                        <button class="lib-button-flat" type="button"
                            [hidden]="!!breakdownScenario?.recommendation?.needs_loan">
                            <lib-icon name="info"></lib-icon>
                            <span>You may not need Proportunity</span>
                        </button>
                        <lib-select hidden class="nav-toggle" theme="stroked" formControlName="product"
                            [options]="productOptions">
                        </lib-select>
                    </nav>

                    <div class="slice-container">
                        <div class="slice mortgage"
                            title="Main Mortgage from a bank or building society which indicates the mortgage percentage against the property value (also known as LTV: Loan to Value)"
                            [style.flex]="breakdownScenario?.recommendation?.mortgage_ltv || 0">
                            <p>{{breakdownScenario?.recommendation?.mortgage_ltv || 0 | percent: '1.0-3'}}</p>
                        </div>
                        <div class="slice proportunity"
                            title="Proportunity's shared equity loan which boosts your overall deposit amount and helps to lower your LTV"
                            [style.flex]="breakdownScenario?.recommendation?.loan_ltv || 0">
                            <p>{{breakdownScenario?.recommendation?.loan_ltv || 0 | percent: '1.0-3'}}</p>
                        </div>
                        <div class="slice deposit" title="Your deposit"
                            [style.flex]="breakdownScenario?.recommendation?.deposit_ltv || 0">
                            <p>{{breakdownScenario?.recommendation?.deposit_ltv || 0 | percent: '1.0-3'}}</p>
                        </div>
                    </div>

                    <span class="lib-spacer-fixed"></span>

                    <div class="flex-r">

                        <!-- <div class="flex-c box">
                            <span class="lib-legend">Purchase Price</span>
                            <h3>{{breakdownScenario?.input?.purchase_price || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div> -->

                        <!-- <hr> -->

                        <div class="flex-c">
                            <span class="lib-legend legend-x">Total borrowing</span>

                            <h3>{{breakdownScenario?.recommendation?.total || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c">
                            <div class="lib-badge mortgage">
                                <span>Mortgage</span>
                                <span>@ {{breakdownScenario?.recommendation?.mortgage_rate | percent: '1.0-2'}}</span>
                                <!-- <span>{{breakdownScenario?.input?.term}}Y TERM</span> -->
                            </div>
                            <h3>{{breakdownScenario?.recommendation?.mortgage || 0 | currency:'GBP':'symbol':'1.0'}}
                            </h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c">
                            <div class="lib-badge proportunity">
                                <span>Proportunity</span>
                                <span>@ {{breakdownScenario?.recommendation?.loan_rate | percent: '1.0-2'}}</span>
                            </div>
                            <h3>{{breakdownScenario?.recommendation?.loan || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c">
                            <div class="lib-badge deposit">
                                <span>Deposit</span>
                            </div>
                            <h3>{{breakdownScenario?.recommendation?.deposit || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>

                    </div>

                    <hr>

                    <div class="flex-r">

                        <!-- <div class="flex-c box">
                            <div class="lib-badge deposit">
                                <span>Deposit</span>
                            </div>
                            <h3>{{breakdownScenario?.recommendation?.deposit || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div> -->

                        <!-- <hr> -->

                        <div class="flex-c highlight-x">
                            <span class="lib-legend legend-x">Per month</span>
                            <h3>{{breakdownScenario?.recommendation?.total_per_month || 0 |
                                currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c">
                            <div class="lib-badge mortgage">
                                <span>Mortgage</span>
                            </div>
                            <h3>{{breakdownScenario?.recommendation?.mortgage_per_month || 0 |
                                currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c">
                            <div class="lib-badge proportunity">
                                <span>Proportunity</span>
                            </div>
                            <h3>{{breakdownScenario?.recommendation?.loan_per_month || 0 |
                                currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-r highlight">
                            <span class="lib-spacer"></span>
                            <button class="lib-button-flat-primary full-width" type="submit">
                                <span>Repayment</span>
                                <span class="lib-spacer"></span>
                                <lib-icon name="chevronRight"></lib-icon>
                            </button>
                        </div>

                    </div>

                </div>

                <span class="lib-spacer"></span>

            </div>

        </form>

    </article>

    <article class="last-child lib-elevation-1" [id]="instanceId + '-repayment'" [class.expand]="step === 'Repayment'">

        <nav class="lib-nav last-child" [class.locked]="step === 'Budget' || step === 'Breakdown'"
            (click)="repaymentGroupToggle($event)">

            <div class="lib-badge" [hidden]="!!listing">
                <span>STEP 3</span>
            </div>
            <h6>Repayment</h6>
            <p class="non-mobile lib-legend">How much could it cost to repay your loan</p>
            <span class="lib-spacer"></span>
            <button *ngIf="step === 'Repayment'" class="lib-button" type="button" (click)="previousStep($event)"
                [hidden]="!!working">
                <lib-icon name="chevronUp"></lib-icon>
            </button>
        </nav>
        <form [formGroup]="repaymentGroup" (ngSubmit)="repaymentGroupSubmit($event)">

            <div class="flex-c">

                <!-- <div class="flex-c container">
                    <nav class="lib-nav">
                        <p>Early repayment charges</p>
                    </nav>

                    <div class="flex-r">

                        <div class="flex-c"
                            *ngFor="let erc of repaymentStore?.product?.annual_early_repayment_charges; index as i">
                            <p class="lib-legend">YEAR {{ i + 1 }}</p>
                            <h6>{{ erc }}%</h6>
                        </div>
                    </div>
                </div> -->

                <span class="lib-spacer"></span>

                <div class="flex-c">
                    <!-- <nav class="lib-nav" hidden>
                        <lib-icon name="gbp"></lib-icon>
                        <p class="only-mobile">Growth &amp; Repayment</p>
                        <p class="non-mobile">Estimated annual growth &amp; Repayment amount</p>
                        <span class="lib-spacer"></span>
                        <lib-select class="nav-toggle" theme="stroked" formControlName="year" [options]="yearOptions">
                        </lib-select>
                    </nav> -->

                    <div class="flex-r center un-pad mx">
                        <div class="flex-c un-pad" hidden>
                            <lib-range formControlName="growth" [options]="growthOptions"></lib-range>
                        </div>
                        <!-- <div class="flex-c">
                            <span class="lib-legend">Repayment year</span>
                            <lib-range formControlName="year" [options]="yearRepaymentOptions"></lib-range>
                        </div> -->
                        <div class="flex-c un-pad">
                            <lib-range formControlName="amount" [options]="repaymentOptions"></lib-range>
                            <!-- <span class="lib-legend">Repayment amount</span>
                            <lib-input prefixIcon="gbp" placeholder="" formControlName="amount" type="number">
                            </lib-input> -->
                        </div>
                    </div>

                    <hr>

                    <nav class="lib-nav xs">
                        <div class="flex-c">
                            <span class="lib-legend">Assuming annual growth of 5%
                                (UK&nbsp;avg&nbsp;last&nbsp;10&nbsp;years)</span>
                        </div>
                        <span class="lib-spacer"></span>
                        <!-- <lib-select class="nav-toggle" theme="stroked" [options]="partFullOptions" [selected]="this.partFullOptions[0].value" (selection)="togglePart($event)">
                        </lib-select>
                        <span class="lib-spacer-fixed"></span> -->
                        <lib-select class="nav-toggle" theme="stroked" formControlName="year" [options]="yearOptions">
                        </lib-select>
                    </nav>

                    <div class="flex-r center">
                        <div class="flex-c">
                            <p class="lib-legend legend-x">Purchase price</p>
                            <h3>{{ repaymentStore?.purchase_price || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div>
                        <!-- <span class="lib-spacer-fixed"></span> -->
                        <div class="flex-c">
                            <p class="lib-legend legend-x">Valuation | year {{repaymentStore?.year + 1}}</p>
                            <h3>{{ repaymentStore?.valuation_price || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div>
                        <!-- <span class="lib-spacer-fixed"></span> -->
                        <div class="flex-r highlight x2">
                            <div class="flex-c">
                                <p class="lib-legend legend-x">Home appreciation</p>
                                <h3>{{ repaymentStore?.price_appreciation || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                            </div>
                            <div class="flex-c x2">
                                <p>You could be able to release equity from the home appreciation to repay the
                                    Proportunity&nbsp;loan.</p>
                            </div>
                        </div>
                        <!-- <span class="lib-spacer-fixed"></span> -->
                        <!-- <div class="flex-c">
                            <p class="lib-legend legend-x">Loan appreciation</p>
                            <h3>{{ repaymentStore?.loan_appreciation || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div> -->
                    </div>

                </div>

                <span class="lib-spacer"></span>
                <span class="lib-spacer-fixed"></span>

                <div class="flex-c container output">
                    <nav class="lib-nav">
                        <lib-icon name="calculator"></lib-icon>
                        <h6>{{!repaymentStore?.remaining ? '' : 'Part-'}}Repayment illustration</h6>
                        <div class="lib-badge">
                            <span>Indicative</span>
                        </div>
                        <span class="lib-spacer"></span>
                    </nav>

                    <div class="flex-r">

                        <div class="flex-c highlight-x">
                            <p class="lib-legend legend-x">Total Payment</p>
                            <h3><strong>{{ repaymentStore?.total || 0 | currency:'GBP':'symbol':'1.0' }}</strong></h3>
                        </div>
                        <!-- <lib-icon name="minus"></lib-icon> -->
                        <!-- <span class="lib-spacer-fixed"></span> -->
                        <div class="flex-c">
                            <p class="lib-legend legend-x">Principal repayment</p>
                            <h3>{{ repaymentStore?.principal || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div>
                        <!-- <lib-icon name="plus"></lib-icon> -->
                        <!-- <span class="lib-spacer-fixed"></span> -->
                        <div class="flex-c">
                            <p class="lib-legend legend-x">Early repayment charge</p>
                            <h3>{{ repaymentStore?.erc || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div>
                        <!-- <lib-icon name="plus"></lib-icon> -->
                        <!-- <span class="lib-spacer-fixed"></span> -->
                        <div class="flex-c">
                            <p class="lib-legend legend-x">Loan appreciation</p>
                            <h3>{{ repaymentStore?.loan_appreciation || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div>
                        <!-- <lib-icon name="plus" [hidden]="!repaymentStore?.discharge"></lib-icon> -->
                        <!-- <span class="lib-spacer-fixed" [hidden]="!repaymentStore?.discharge"></span> -->
                        <div class="flex-c" [hidden]="!repaymentStore?.discharge">
                            <p class="lib-legend legend-x">Discharge fee</p>
                            <h3>{{repaymentStore?.discharge || 0 | currency:'GBP':'symbol':'1.0'}}</h3>
                        </div>

                    </div>
                    <hr>
                    <!---->
                    <div class="flex-r remaining" [hidden]="!repaymentStore?.remaining">
                        <div class="flex-c"></div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c">
                            <p class="lib-legend legend-x">Remaining principal</p>
                            <h3>{{ repaymentStore?.remaining || 0 | currency:'GBP':'symbol':'1.0' }}</h3>
                        </div>
                        <span class="lib-spacer-fixed"></span>
                        <div class="flex-c x2" [hidden]="repaymentStore?.can_estimate_thereafter">
                            <p>Due to variable interest rates we are unable to representatively estimate monthly payment
                                amount beyond end of term.</p>
                        </div>
                        <div class="flex-c" [hidden]="!repaymentStore?.can_estimate_thereafter">
                            <p class="lib-legend legend-x">Proportunity Per month<br>thereafter</p>
                            <h3>{{ repaymentStore?.per_month_thereafter || 0 | currency:'GBP':'symbol':'1.0' }}
                                <span class="lib-legend">( -{{ repaymentStore?.per_month_total_thereafter_delta || 0 |
                                    currency:'GBP':'symbol':'1.0' }} )</span>
                            </h3>
                        </div>
                        <span class="lib-spacer-fixed" [hidden]="!repaymentStore?.can_estimate_thereafter"></span>
                        <div class="flex-c" [hidden]="!repaymentStore?.can_estimate_thereafter">
                            <p class="lib-legend legend-x">Total Per month<br>thereafter</p>
                            <h3>{{ repaymentStore?.per_month_total_thereafter || 0 | currency:'GBP':'symbol':'1.0' }}
                                <!-- <span class="lib-legend">(-{{ repaymentStore?.per_month_total_thereafter_delta || 0 |
                                    currency:'GBP':'symbol':'1.0' }})</span> -->
                            </h3>
                        </div>
                        <!--
                        <div class="flex-c"></div> -->
                    </div>
                    <div class="flex-c remaining" [hidden]="repaymentStore?.remaining">
                        <p class="h">We find most of our customers are often given the
                            opportunity to remortgage at the end of years 2 and 5.</p>
                    </div>
                </div>

                <span class="lib-spacer"></span>

            </div>

        </form>

    </article>

    <!-- <app-representative-example></app-representative-example> -->

</div>